export const LAYOUT_COMPONENTS_NS = 'layoutComponents';

export const i18n = {
  en: {
    names: {
      text: 'Text',
      number: 'Number',
      assetSearch: 'Asset Search',
      peopleSearch: 'People Search',
      date: 'Date',
      select: 'Select',
      advancedSelect: 'Advanced Select',
      advancedText: 'Advanced Text',
      toggle: 'Toggle',
      signature: 'Signature',
      slider: 'Slider',
      attachments: 'Attachments',
      financeTable: 'Finance Table',
      table: 'Table',
      section: 'Section',
      banner: 'Banner',
      advancedEditor: 'Advanced Editor',
      sectionConfiguration: 'Section configuration',
    },
    configurators: {
      general: 'General',
      basic: 'Basic',
      overview: 'Overview',
      properties: 'Properties',
      columns: 'Columns',
      settings: 'Settings',
      advanced: 'Advanced',
    },
    actions: {
      openInEditor: 'Open in editor',
      importAssetType: 'Import asset type',
      changeType: 'Change type',
      duplicate: 'Duplicate',
      hideComponent: 'Hide component',
      showComponent: 'Show component',
      resetConfiguration: 'Reset configuration',
      delete: 'Delete',
      proceed: 'Proceed',
    },
    tooltips: {
      deleteColumn: 'Delete column',
      columnDetails: 'Column details',
      deleteSection: 'Delete section',
      deleteComponent: 'Delete component',
    },
    gridColumnTypes: {
      text: 'Text',
      number: 'Number',
      thing: 'Asset Search',
      date: 'Date',
      select: 'Select',
      booleanSwitch: 'Toggle',
      link: 'Link',
    },
    labels: {
      name: 'Name',
      title: 'Title',
      assetType: 'Asset type',
      addAColumn: 'Add a column',
      columnSettings: 'Column settings',
      reset: 'Reset',
      resetColumn: 'Reset column',
      changeDataSource: 'Change data source',
      learnMore: 'Learn More',
      rowsReordering: 'Rows reordering',
      columnsReordering: 'Columns reordering',
      pinningColumns: 'Pinning columns',
      readOnly: 'Read only',
      sorting: 'Sorting',
      editing: 'Editing',
      grouping: 'Grouping',
      editSubject: 'Edit {{ subject }}',
      property: 'Property',
      product: 'Product',
      currency: 'Currency',
      tableName: 'Table name',
      addingTableRows: 'Adding table rows',
      addRows: 'Add Rows',
      column: 'Column',
      columnType: 'Column Type',
      columnName: 'Column Name',
      untitledSection: 'Untitled section',
      untitledTable: 'Untitled table',
      value: 'Value',
      properties: 'Properties',
      addAnOption: 'Add an option',
      option: 'Option',
      optionText: 'Option Text',
      yes: 'Yes',
      no: 'No',
      enabled: 'Enabled',
      disabled: 'Disabled',
      description: 'Description',
      hideComponent: 'Hide component',
      textWrapping: 'Wrap all columns',
      sectionName: 'Section name',
      changeComponent: 'Change component type',
    },
    propertyLabels: {
      label: 'Label',
      placeholder: 'Placeholder',
      helpText: 'Help text (tooltip)',
      rangeMin: 'Range Min',
      rangeMax: 'Range Max',
      incrementBy: 'Increment By',
      enabledLabel: 'Enabled label',
      disabledLabel: 'Disabled label',
      defaultView: 'Default view',
      connectWith: 'Connect with',
      dataSource: 'Data source',
      field: 'Field',
      type: 'Type',
      property: 'Property',
      dateRange: 'Date range',
      time: 'Time',
      multiselect: 'Multiselect',
      readOnly: 'Read only',
      required: 'Required',
      createNewAssets: 'Create new Assets',
      inviteNewUsers: 'Invite new users',
      addNewItem: 'Add new item',
      contextualSearch: 'Contextual search',
      decimals: 'Decimals',
      defaultValue: 'Default value',
      defaultData: 'Default data',
      collapsible: 'Collapsible',
    },
    propertyHints: {
      incrementBy:
        'Please enter the increment number that divides your max range value without remainder',
    },
    dataSourceLabels: {
      none: 'None',
      thisWork: 'This Work',
      asset: 'Asset',
      people: 'People',
      customData: 'Custom Data',
    },
    defaultValueLabels: {
      description: 'Link a Component or add custom data',
      fromThisFlow: {
        workflowTitle: 'From this Workflow',
        assetTypeTitle: 'From this Asset Type',
        description:
          'Choose a Component that, when its value is entered, will populate this Component',
        datePickerDescription:
          'Choose a Date Picker Component that, when its value is entered, will populate this Component',
        textInputDescription:
          'Choose a Text Component that, when its value is entered, will populate this Component',
        textAreaDescription:
          'Choose a Text Area Component that, when its value is entered, will populate this Component',
        numberInputDescription:
          'Choose a Number Component that, when its value is entered, will populate this Component',
        tableDescription:
          'Choose a Table Component that, when its values are entered, will populate this Component if the column names match\n',
        peopleSearchDescription:
          'Choose a People Search Component that, when its value is selected, will populate this Component',
        assetSearchDescription:
          'Choose a Asset Search Component that, when its value is entered, will populate this Component',
      },
      assetProperty: {
        title: 'Asset property',
        description:
          'Choose an Asset Search Component that, when an Asset is selected, the relevant Asset property will populate this Component',
      },
      initiator: {
        title: 'Task initiator',
        description: 'Automatically populates the field with the work initiator or task assignee.',
      },
      customValue: {
        title: 'Custom data',
        tableTitle: 'Custom Data',
        description: 'Enter your own data',
        tableDescription: 'Pre-fill the table with your own values',
      },
      calculation: {
        title: 'Calculation',
        description:
          'Perform arithmetic operations on selected properties and display the results in a field.',
      },
      assetSearchComponent: 'Asset Search Component',
      linkComponent: 'Link component',
      learnMore: 'Learn more about default values',
    },
    userEntityProperties: {
      displayName: 'Display Name',
      email: 'Email',
    },
    descriptions: {
      text: 'Allows users to enter text or numerical data',
      number:
        'Allows users to enter numerical data, with options to capture a specific number of decimals',
      assetSearch: 'Allows users to select an asset from a pre defined asset type',
      peopleSearch:
        'Allows users to select another user, with selection options being filtered by the searching user’s company and work connections',
      date: 'Allows users to select a date, with options to capture time and/or a range of dates',
      select: 'Allows users to select one or more options from a pre defined list',
      advancedSelect:
        'Allows users to select one or more options from a pre defined list while also capturing additional information',
      advancedText: 'Allows users to have greater formatting control in a longer text input',
      toggle: 'Allows users to toggle between an enabled and disabled state',
      signature: 'Allows users to capture their handwritten signature',
      slider: 'Allows users to select a number from a set range and interval',
      attachments: 'Allows users to upload files',
      financeTable:
        'Allows users to input monetary information and automatically calculate discounts, taxes and totals',
      table:
        'Allows users to view and edit data in a tabular format, with options to have a range of column types',
      section: 'Allows greater customisation of the layout of your workflow',
      banner: 'Presents informations to users but is not editable by them',
      linkComponent: 'Link the components from this work as an intake source.',
      prefillTable: 'Pre-fill your table with custom data as a default source.',
      customTableData: 'What users will see in the table? Pre-fill your table with custom data.',
      missingConfigurators: 'Missing configurators for {{name}}',
      changeComponentTypeWarning: 'By changing field type Data Source selection will be reset.',
      changeComponentTypeNote: 'Note: after proceeding select the applicable Data source option.',
      deleteTableColumnNote: 'Note: The column configuration and dependencies will be lost.',
      loseCustomDataNote: 'Note: You will lose all custom data that has been filled in.',
    },
    placeholders: {
      enterTitle: 'Enter title',
      enterAShortHint: 'Enter a short hint',
      selectAValue: 'Select a value',
      enterTableName: 'Enter a table name',
      enterColumnName: 'Enter Column name',
      linkOrAddCustomData: 'Link a component or add custom data',
      enterRangeMin: 'Enter range min',
      enterRangeMax: 'Enter range max',
      enterIncrementNumber: 'Enter increment number',
      enterShortHint: 'Enter a short hint',
      enterEnabledLabel: 'Enter enabled label',
      enterDisabledLabel: 'Enter disabled label',
      noOptions: 'No Options',
      selectDecimals: 'Select decimals',
      typeDescription: 'Type a description...',
      selectAssetTypeOption: 'Select an option or type to create one',
      sectionName: 'Enter section name',
      tooltip: 'Displays helper text in a tooltip to provide additional guidance to users',
    },
    prompts: {
      deleteColumn: 'Are you sure you want to delete this column?',
      sureToDeleteSubject: 'Are you sure to delete {{ subject }}?',
    },
    errors: {
      columnNameMustBeUnique: 'Column name has to be unique',
      componentError: 'Component Error',
      requiredField: 'Required field',
      cannotLessThan: 'Cannot be less than {{ value }}',
      cannotGreaterThan: 'Cannot be greater than {{ value }}',
      rangeNotDivisibleBy: 'The range is not divisible by {{ divisor }}',
      subjectIsRequired: '{{ subject }} is required',
      subjectShouldBeUnique: '{{ subject }} should be unique',
      subjectShouldStartWithValue: '{{ subject }} should start with {{ value }}',
      atLeast1ItemIsRequired: 'At least 1 {{ item }} is required',
      labelShouldBeUnique: 'Label should be unique',
      missingRequiredInformation: 'Missing required information',
      notAllRequiredFieldsAreFilled: 'Not all required fields are filled',
      somethingWentWrong: 'Something went wrong',
      failedToOpenAdvancedEditor: 'Failed to open advanced editor',
      sectionEmptyName: 'Section name cannot be empty',
    },
  },
};
